import styled from 'styled-components'

export const Main = styled.div`
text-align:left;
padding:80px 150px;
@media screen and (max-width:768px){
    padding:10px;
}
`